import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { collectionData, shopProductData } from "../../helper/staticData";
import Breadcrumb from "../../Component/Breadcrumb";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination, Thumbs } from "swiper/modules";
import moment from "moment";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import { toast } from "react-toastify";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import useBreakPoints from "../../hooks/useBreakPoints";
import { MyContext } from "../../hooks/useContextProvider";
import Login from "../Authentication/Login";
import DeepLinkHelper from "../../helper/deepLinkHelper";
import OpenInAppBanner from "../../Component/OpenInAppBanner";

const ProductDetails = () => {
  const parmas = useParams();
  const { token, callCartDetails, cartList, callWishListApi, wishList } =
    useContext(MyContext);
  const { isMobile, isTablet, isLaptop } = useBreakPoints();
  const navigate = useNavigate();
  const [loginModal, setLoginModal] = useState(false);
  const [product, setProduct] = useState({});
  const [tab, setTab] = useState("description");
  const [loading, setLoading] = useState(false);
  const [addReviewStatus, setAddReviewStatus] = useState(false);
  const [alreadyReviewStatus, setAlreadyReviewStatus] = useState(false);
  const [ratingInputData, setRatingInputData] = useState({
    rating: "0",
    description: "",
  });
  const [mainSwiper, setMainSwiper] = useState(null);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [qty, setQty] = useState(1);
  const [variant, setVariant] = useState([]);
  const [selectedVariantType, setSelectedVariantType] = useState({});
  const [selectedVariant, setSelectedVariant] = useState();
  const [addReviewModal, setAddReviewModal] = useState(false);
  const [descriptionError, setDescriptionError] = useState("");
  const [showOpenInAppBanner, setShowOpenInAppBanner] = useState(false);

  // Auto-open app on page load (for shared links)
  useEffect(() => {
    if (parmas?.id && DeepLinkHelper.isMobileDevice()) {
      console.log(
        "🔗 [PAGE_LOAD] Attempting auto-open for product:",
        parmas?.id
      );
      DeepLinkHelper.autoOpenApp(parseInt(parmas?.id));

      // Show banner after auto-open attempt
      setTimeout(() => {
        setShowOpenInAppBanner(true);
      }, 3000);
    }
  }, [parmas?.id]);

  const getProductDetailById = async () => {
    let formData = new FormData();
    formData.append("productId", parmas?.id);
    setLoading(true);

    const token = localStorage.getItem("token");
    const ipAddress = localStorage.getItem("ipaddress");

    await fetch(
      `${process.env.REACT_APP_API_URL}productdetailsbyproduct?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,

          // "Content-Type": "application/json",
        },
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" ||
            data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          window.location.reload();
        }
        if (data && data.status) {
          let product = data?.productList[0];

          let arr3 = [];
          let arr4 = [];
          product?.attributes?.map((er) => {
            let check = arr3?.findIndex((qw) => qw === er?.name);
            if (check === -1) {
              arr3?.push(er?.name);
            }
          });
          product?.attributes?.map((er) => {
            let check = arr4?.findIndex((qw) => qw?.name === er?.name);
            if (check === -1) {
              arr4?.push({
                name: er?.name,
                variants: [{ variant: er?.value, id: er?.id }],
              });
            } else {
              arr4[check]["variants"]?.push({ variant: er?.value, id: er?.id });
            }
          });
          let totalProductStock = product?.variants?.reduce(
            (acc, num) => parseInt(acc + parseInt(num?.stock)),
            0
          );
          let obj = {
            id: product?.id,
            brands: [],
            category: [
              product?.mainCategoryDetails && {
                name: product?.mainCategoryDetails?.mainCategoryName,
                id: product?.mainCategoryDetails?.id,
              },
              product?.categoryDetails && {
                name: product?.categoryDetails?.categoryName,
                id: product?.categoryDetails?.id,
              },
              product?.subCategoryDetails && {
                name: product?.subCategoryDetails?.subCategoryName,
                id: product?.subCategoryDetails?.id,
              },
            ],
            featured: null,
            name: product?.productName,
            new: null,
            pictures: JSON?.parse(product?.productGallery),
            sm_pictures: JSON?.parse(product?.productGallery),
            price: product?.productPrice,
            review: null,
            ratings: 4,
            sale_price: null,
            discountedPercentage: product?.discountedPercentage,
            isDiscountApplicable: product?.isDiscountApplicable,
            short_desc: product?.productShortDescription,
            long_desc: product?.productDescription,
            add_info: product?.additionalInformation,
            sold: null,
            stock: totalProductStock,
            top: true,
            until: null,
            variants: product?.variants,
            attributes: arr3,
            variantsType: arr4,
            maxQuantity: product?.maxQuantity,
            minQuantity: product?.minQuantity,
            userRatingsDetails: product?.userRatingsDetails,
            averageRatingsDetails: product?.averageRatingsDetails,
            relatedProducts: product?.related_products,
          };
          setVariant(
            product?.variants?.map((item) => ({
              ...item,
              name1: item?.attributeDetails?.value,
              name2:
                item?.variantkey?.split("-")?.[0] ===
                item?.attributeDetails?.value
                  ? item?.attributeDetails?.value
                  : item?.variantkey?.split("-")?.[0] || "" || "",
              name3: item?.variantkey?.split("-")?.[1] || "" || "",
              variantImageGallery:
                (item?.variantImageGallery?.length > 0 &&
                  JSON?.parse(
                    item?.variantImageGallery?.replace(/'/g, '"') || []
                  )) ||
                [],
            }))
          );

          setProduct(obj);
          if (token) {
            callOrderTrackingByProductApi();
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("There was an error, Please try again later.");
      });
  };

  useEffect(() => {
    getProductDetailById();
  }, [parmas]);

  useEffect(() => {
    if (product?.id) {
      let obj = { name1: variant[0]?.name1 };
      if (variant[0]?.name2?.length > 0) {
        obj.name2 = variant[0]?.name2;
      }
      if (variant[0]?.name3?.length > 0) {
        obj.name3 = variant[0]?.name3;
      }

      setSelectedVariantType(obj);
    }
  }, [product]);

  useEffect(() => {
    if (selectedVariantType) {
      if (product?.variantsType?.length === 1) {
        let findVarient = variant?.find(
          (er) => er?.attributeDetails?.value === selectedVariantType?.name1
        );
        if (findVarient) {
          setSelectedVariant(findVarient);
        }
      } else if (product?.variantsType?.length === 2) {
        let var1 = selectedVariantType?.name1;

        let var2 = "";
        if (selectedVariantType?.name1) {
          var2 = selectedVariantType?.name1;
        }

        if (selectedVariantType?.name3) {
          var2 = var2 + "-" + selectedVariantType?.name3;
        }

        let findVarient = variant?.find((er) =>
          var2?.length > 0
            ? er?.attributeDetails?.value === var1 && er?.variantkey === var2
            : er?.attributeDetails?.value === var1
        );
        if (findVarient) {
          setSelectedVariant(findVarient);
        }
      } else {
        let var1 = selectedVariantType?.name1;

        let var2 = "";
        if (selectedVariantType?.name2) {
          var2 = selectedVariantType?.name2;
        }

        if (selectedVariantType?.name3) {
          var2 = var2 + "-" + selectedVariantType?.name3;
        }

        let findVarient = variant?.find((er) =>
          var2?.length > 0
            ? er?.attributeDetails?.value === var1 && er?.variantkey === var2
            : er?.attributeDetails?.value === var1
        );
        if (findVarient) {
          setSelectedVariant(findVarient);
        }
      }
    }
  }, [
    selectedVariantType?.name1,
    selectedVariantType?.name2,
    selectedVariantType?.name3,
  ]);

  const handleSubmitReview = async (e) => {
    if (!ratingInputData?.rating) {
      toast.error("Please Enter a Rating!", { toastId: "ratingErr" });
    } else if (!ratingInputData?.description) {
      toast.error("Please Enter a Description!", { toastId: "descErr" });
      setDescriptionError(true);
    } else if (ratingInputData?.description?.length <= 2) {
      toast.error("Please Enter a Proper Description!", {
        toastId: "descErr2",
      });
      setDescriptionError(true);
    } else {
      setLoading(true);

      let userInfo = JSON.parse(localStorage.getItem("userDetails"));

      let formData = new FormData();

      formData.append("customerId", userInfo?.id);
      formData.append("productId", product?.id);
      formData.append("starRating", ratingInputData?.rating);
      formData.append("reviewComment", ratingInputData?.description);
      formData.append("ratingDate", moment().format("YYYY-MM-DD"));
      formData.append("created_by", userInfo?.customerName);
      formData.append("clientId", process.env.REACT_APP_Client_Id);

      const token = localStorage.getItem("token");
      const ipAddress = localStorage.getItem("ipaddress");

      await fetch(
        `${process.env.REACT_APP_API_URL}adduserratings?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,

        {
          method: "POST",
          headers: {
            Authorization: `Token ${token}`,
          },
          body: formData,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" ||
              data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }
          if (data && data.status) {
            let product = data?.productList[0];
            toast.success("Review Add Successfully");
            setAddReviewModal(false);
            getProductDetailById();

            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error("There was an error, Please try again later.");
        });
    }
  };

  const handleCartBtn = (productDetails) => {
    if (!token) {
      setLoginModal(true);
    } else {
      setLoading(true);

      let userInfo = JSON.parse(localStorage.getItem("userDetails"));
      let ipAddress = localStorage.getItem("ipaddress");
      let formData = new FormData();

      formData.append("customerId", userInfo?.id);
      formData.append("clientId", process.env.REACT_APP_Client_Id);
      formData.append("productId", productDetails?.id);
      formData.append(
        "productAttributeId",
        selectedVariant?.attributeDetails?.id
      );
      formData.append("productVariantId", selectedVariant?.id);
      formData.append("qty", qty);
      formData.append("created_by", "");
      formData.append("updated_by", "");
      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}addcart?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" ||
              data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }
          if (data && data.status) {
            setLoading(false);
            navigate("/cart");
            callCartDetails();
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          setTimeout(() => {
            toast.error("There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    }
  };

  const handleWhishListBtn = (productDetails) => {
    if (!token) {
      setLoginModal(true);
    } else {
      setLoading(true);

      let userInfo = JSON.parse(localStorage.getItem("userDetails"));
      let ipAddress = localStorage.getItem("ipaddress");
      let formData = new FormData();

      formData.append("customerId", userInfo?.id);
      formData.append("clientId", process.env.REACT_APP_Client_Id);
      formData.append("productId", productDetails?.id);
      formData.append("created_by", "");

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}addwishlist?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" ||
              data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }
          if (data && data.status) {
            setLoading(false);
            callWishListApi();
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          setTimeout(() => {
            toast.error("There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    }
  };

  const callOrderTrackingByProductApi = async () => {
    try {
      let userInfo = JSON.parse(localStorage.getItem("userDetails"));
      let formData = new FormData();
      formData.append("productId", parmas?.id);
      formData.append("customerId", userInfo?.id);

      const token = localStorage.getItem("token");
      const ipAddress = localStorage.getItem("ipaddress");

      await fetch(
        `${process.env.REACT_APP_API_URL}productbuytracking?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        {
          method: "POST",
          headers: {
            Authorization: `Token ${token}`,

            // "Content-Type": "application/json",
          },
          body: formData,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" ||
              data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }

          if (data.status) {
            setAddReviewStatus(data?.status);
            setLoading(false);
          } else if (
            data.message ===
            "Product has already been reviewed by the customer."
          ) {
            setAlreadyReviewStatus(true);
            setAddReviewStatus(data?.status);
            setLoading(false);
          } else {
            setAlreadyReviewStatus(false);
            setAddReviewStatus(data?.status);
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error("There was an error, Please try again later.");
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb
        mainTitle={"Shop"}
        title={product?.category?.[0]?.["name"]}
        subTitle={"Home"}
        title2={product?.name}
      />
      <div id="main">
        <div class="wdt-elementor-container-fluid">
          <section id="primary" class="content-full-width">
            <div class="woocommerce-notices-wrapper"></div>
            <div
              id="product-1621"
              class="product-grid-view product type-product post-1621 status-publish first instock product_cat-sofa product_tag-chair has-post-thumbnail sale shipping-taxable purchasable product-type-variable has-default-attributes"
            >
              <div
                data-elementor-type="wp-post"
                data-elementor-id="1621"
                class="elementor elementor-1621"
              >
                <section
                  class="custom-slider-home-2 elementor-section elementor-top-section elementor-element elementor-element-cbe09e3 elementor-section-boxed elementor-section-height-default elementor-section-height-default "
                  data-id="cbe09e3"
                  data-element_type="section"
                  data-settings='{"animation":"fadeInUp","animation_delay":200,"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
                >
                  <div class="elementor-container elementor-column-gap-no">
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-4c4f964 wdt-cus-sticky-column"
                      data-id="4c4f964"
                      data-element_type="column"
                    >
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div
                          class="elementor-element elementor-element-33820a2 elementor-widget elementor-widget-wdt-shop-product-single-images-carousel"
                          data-id="33820a2"
                          data-element_type="widget"
                          data-settings='{"carousel_slidesperview":"1","carousel_slidesperview_laptop":"1","carousel_slidesperview_tablet_extra":"1","carousel_slidesperview_tablet":"1","carousel_slidesperview_mobile_extra":1,"carousel_slidesperview_mobile":1,"wdt_animation_effect":"none"}'
                          data-widget_type="wdt-shop-product-single-images-carousel.default"
                        >
                          <div class="elementor-widget-container">
                            <div class="wdt-product-image-gallery-holder wdt-product-vertical-thumb wdt-product-vertical-thumb-left">
                              <Swiper
                                className="wdt-product-image-gallery-container wdt-product-image-gallery-33820a2 swiper-container"
                                modules={[Navigation, Thumbs]}
                                onSwiper={setMainSwiper} // Store Swiper instance in state
                                thumbs={{ swiper: thumbsSwiper }} // Link to thumbnail Swiper
                                wrapperClass="wdt-product-image-gallery swiper-wrapper " // Custom class for swiper-wrapper
                              >
                                {selectedVariant?.variantImageGallery?.map(
                                  (image, index) => (
                                    <SwiperSlide
                                      key={index}
                                      className="wdt-product-image"
                                    >
                                      <img
                                        src={image}
                                        alt="Product Image"
                                        loading="lazy"
                                        decoding="async"
                                        width="1000"
                                        height="1024"
                                        class=""
                                        sizes="(max-width: 1000px) 100vw, 1000px"
                                      />
                                    </SwiperSlide>
                                  )
                                )}
                              </Swiper>
                              <div className="wdt-product-image-gallery-pagination-holder"></div>

                              {/* Thumbnail Swiper */}
                              <Swiper
                                className="wdt-product-image-gallery-thumb-container swiper-container swiper-initialized swiper-vertical swiper-backface-hidden swiper-thumbs"
                                modules={[Thumbs]}
                                wrapperClass="wdt-product-image-gallery-thumb swiper-wrapper custom-gap custom-product-slidebar"
                                onSwiper={setThumbsSwiper} // Store Swiper instance
                                watchSlidesProgress={true} // Keeps track of active slide
                              >
                                {selectedVariant?.variantImageGallery?.map(
                                  (thumb, index) => (
                                    <SwiperSlide
                                      key={index}
                                      onClick={() => mainSwiper?.slideTo(index)}
                                      style={{
                                        height: 155.25,
                                        marginBottom: 20,
                                      }}
                                      className="swiper-slide swiper-slide-visible swiper-slide-prev"
                                    >
                                      <img
                                        src={thumb}
                                        style={{ height: 166, width: 139 }}
                                        height={166}
                                        width={139}
                                        alt="Gallery Thumb"
                                      />
                                    </SwiperSlide>
                                  )
                                )}
                              </Swiper>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-a86931b"
                      data-id="a86931b"
                      data-element_type="column"
                    >
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div
                          class="elementor-element elementor-element-2b25481 elementor-widget elementor-widget-wdt-shop-product-single-summary"
                          data-id="2b25481"
                          data-element_type="widget"
                          data-settings='{"wdt_animation_effect":"none"}'
                          data-widget_type="wdt-shop-product-single-summary.default"
                        >
                          <div class="elementor-widget-container">
                            <div class="wdt-product-summary summary entry-summary">
                              <div class="wdt-product-summary-additional-content">
                                <p>{product?.category?.[0]?.["name"]}</p>
                              </div>
                              <div
                                class="wdt-single-product-title"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                }}
                              >
                                <h2
                                  class="product_title entry-title"
                                  style={{ margin: 0, flex: 1 }}
                                >
                                  {product?.name}
                                </h2>
                                {/* Open in App Button for Mobile */}
                                {DeepLinkHelper.isMobileDevice() &&
                                  product?.id && (
                                    <button
                                      onClick={() => {
                                        DeepLinkHelper.tryOpenInApp(
                                          product.id,
                                          () => {
                                            const shouldDownload =
                                              window.confirm(
                                                "K9 Interior app is not installed. Would you like to download it?"
                                              );
                                            if (shouldDownload) {
                                              DeepLinkHelper.openAppStore();
                                            }
                                          }
                                        );
                                      }}
                                      style={{
                                        backgroundColor: "#0C831F",
                                        color: "white",
                                        border: "none",
                                        padding: "8px 16px",
                                        borderRadius: "6px",
                                        fontSize: "13px",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      📱 Open in App
                                    </button>
                                  )}
                              </div>
                              <div class="woocommerce-product-rating">
                                <div
                                  class="star-rating"
                                  role="img"
                                  aria-label="Rated 4.00 out of 5"
                                >
                                  <span
                                    style={{
                                      width: `${
                                        (product?.averageRatingsDetails?.[0]
                                          ?.averageRating /
                                          5) *
                                        100
                                      }%`,
                                    }}
                                  >
                                    Rated{" "}
                                    <strong class="rating">
                                      {
                                        product?.averageRatingsDetails?.[0]
                                          ?.averageRating
                                      }
                                      .00
                                    </strong>{" "}
                                    out of 5 based on{" "}
                                    <span class="rating">
                                      {product?.averageRatingsDetails?.length +
                                        1}
                                    </span>{" "}
                                    customer rating
                                  </span>
                                </div>
                                <Link
                                  class="woocommerce-review-link"
                                  rel="nofollow"
                                >
                                  (
                                  <span class="count">
                                    {product?.averageRatingsDetails?.length}
                                  </span>{" "}
                                  customer review)
                                </Link>
                              </div>

                              <div class="wdt-single-product-separator"></div>
                              <div class="wdt-single-product-price">
                                {product?.discountedPercentage ? (
                                  <div>
                                    <p style={{ marginBottom: 0 }}>
                                      {product?.discountedPercentage && (
                                        <span
                                          style={{
                                            color: "#CC0C39",
                                            fontSize: 24,
                                          }}
                                        >
                                          - {product?.discountedPercentage}%
                                        </span>
                                      )}{" "}
                                      &nbsp;{" "}
                                      <span
                                        style={{ color: "black", fontSize: 24 }}
                                      >
                                        {" "}
                                        &#8377;{" "}
                                        {parseFloat(selectedVariant?.price) -
                                          (selectedVariant?.price *
                                            product?.discountedPercentage) /
                                            100}
                                      </span>
                                    </p>
                                    {product?.discountedPercentage && (
                                      <p
                                        style={{
                                          fontSize: 12,
                                          marginBottom: 0,
                                          marginTop: 8,
                                          textDecoration: "line-through",
                                        }}
                                        class="woocommerce-Price-amount amount"
                                      >
                                        <bdi>
                                          <span class="woocommerce-Price-currencySymbol">
                                            M.R.P. : &#8377;
                                          </span>
                                          &nbsp;{selectedVariant?.price}
                                        </bdi>
                                      </p>
                                    )}
                                  </div>
                                ) : (
                                  <p class="price">
                                    <span
                                      class="woocs_price_code"
                                      data-currency=""
                                      data-redraw-id="67b41b547c038"
                                      data-product-id="1621"
                                    >
                                      &nbsp;
                                      <span class="woocommerce-Price-amount amount">
                                        <bdi>
                                          <span class="woocommerce-Price-currencySymbol">
                                            &#8377;
                                          </span>
                                          &nbsp;
                                          {parseFloat(
                                            parseFloat(selectedVariant?.price) -
                                              (selectedVariant?.price *
                                                product?.discountedPercentage) /
                                                100
                                          ).toFixed(2)}
                                        </bdi>
                                      </span>
                                    </span>
                                  </p>
                                )}
                              </div>
                              <div class="wdt-single-product-separator"></div>
                              <div class="product-buttons-wrapper product-button product-button-cart">
                                <div class="wc_inline_buttons">
                                  <div class="wcwl_btn_wrapper wc_btn_inline">
                                    <form
                                      class="variations_form cart"
                                      action="https://furniforma.wpengine.com/product/garden-chair/"
                                      method="post"
                                      enctype="multipart/form-data"
                                      data-product_id="1621"
                                      data-product_variations='[{"attributes":{"attribute_pa_color":""},"availability_html":"&lt;p class=\"stock in-stock\"&gt;150 in stock&lt;\/p&gt;\n","backorders_allowed":false,"dimensions":{"length":"","width":"","height":""},"dimensions_html":"N\/A","display_price":102,"display_regular_price":105,"image":{"title":"FF-product-img-3-01","caption":"","url":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","alt":"FF-product-img-3-01","src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","srcset":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png 1000w, https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-293x300.png 293w, https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-768x786.png 768w, https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-50x50.png 50w","sizes":"(max-width: 1000px) 100vw, 1000px","full_src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","full_src_w":1000,"full_src_h":1024,"gallery_thumbnail_src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-100x100.png","gallery_thumbnail_src_w":100,"gallery_thumbnail_src_h":100,"thumb_src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","thumb_src_w":1000,"thumb_src_h":1024,"src_w":1000,"src_h":1024},"image_id":1884,"is_downloadable":false,"is_in_stock":true,"is_purchasable":true,"is_sold_individually":"no","is_virtual":false,"max_qty":150,"min_qty":1,"price_html":"&lt;span class=\"price\"&gt;&lt;span class=\"woocs_price_code\" data-currency=\"\" data-redraw-id=\"67b41b547c97e\"  data-product-id=\"1622\"&gt;&lt;del aria-hidden=\"true\"&gt;&lt;span class=\"woocommerce-Price-amount amount\"&gt;&lt;bdi&gt;&lt;span class=\"woocommerce-Price-currencySymbol\"&gt;&amp;#36;&lt;\/span&gt;&amp;nbsp;105.00&lt;\/bdi&gt;&lt;\/span&gt;&lt;\/del&gt; &lt;span class=\"screen-reader-text\"&gt;Original price was: &amp;#036;&amp;nbsp;105.00.&lt;\/span&gt;&lt;ins aria-hidden=\"true\"&gt;&lt;span class=\"woocommerce-Price-amount amount\"&gt;&lt;bdi&gt;&lt;span class=\"woocommerce-Price-currencySymbol\"&gt;&amp;#36;&lt;\/span&gt;&amp;nbsp;102.00&lt;\/bdi&gt;&lt;\/span&gt;&lt;\/ins&gt;&lt;span class=\"screen-reader-text\"&gt;Current price is: &amp;#036;&amp;nbsp;102.00.&lt;\/span&gt;&lt;\/span&gt;&lt;\/span&gt;","sku":"","variation_description":"","variation_id":1622,"variation_is_active":true,"variation_is_visible":true,"weight":"","weight_html":"N\/A"},{"attributes":{"attribute_pa_color":"brown"},"availability_html":"&lt;p class=\"stock in-stock\"&gt;150 in stock&lt;\/p&gt;\n","backorders_allowed":false,"dimensions":{"length":"","width":"","height":""},"dimensions_html":"N\/A","display_price":90,"display_regular_price":95,"image":{"title":"FF-product-img-3-01","caption":"","url":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","alt":"FF-product-img-3-01","src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","srcset":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png 1000w, https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-293x300.png 293w, https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-768x786.png 768w, https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-50x50.png 50w","sizes":"(max-width: 1000px) 100vw, 1000px","full_src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","full_src_w":1000,"full_src_h":1024,"gallery_thumbnail_src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-100x100.png","gallery_thumbnail_src_w":100,"gallery_thumbnail_src_h":100,"thumb_src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","thumb_src_w":1000,"thumb_src_h":1024,"src_w":1000,"src_h":1024},"image_id":1884,"is_downloadable":false,"is_in_stock":true,"is_purchasable":true,"is_sold_individually":"no","is_virtual":false,"max_qty":150,"min_qty":1,"price_html":"&lt;span class=\"price\"&gt;&lt;span class=\"woocs_price_code\" data-currency=\"\" data-redraw-id=\"67b41b547d2e1\"  data-product-id=\"1623\"&gt;&lt;del aria-hidden=\"true\"&gt;&lt;span class=\"woocommerce-Price-amount amount\"&gt;&lt;bdi&gt;&lt;span class=\"woocommerce-Price-currencySymbol\"&gt;&amp;#36;&lt;\/span&gt;&amp;nbsp;95.00&lt;\/bdi&gt;&lt;\/span&gt;&lt;\/del&gt; &lt;span class=\"screen-reader-text\"&gt;Original price was: &amp;#036;&amp;nbsp;95.00.&lt;\/span&gt;&lt;ins aria-hidden=\"true\"&gt;&lt;span class=\"woocommerce-Price-amount amount\"&gt;&lt;bdi&gt;&lt;span class=\"woocommerce-Price-currencySymbol\"&gt;&amp;#36;&lt;\/span&gt;&amp;nbsp;90.00&lt;\/bdi&gt;&lt;\/span&gt;&lt;\/ins&gt;&lt;span class=\"screen-reader-text\"&gt;Current price is: &amp;#036;&amp;nbsp;90.00.&lt;\/span&gt;&lt;\/span&gt;&lt;\/span&gt;","sku":"","variation_description":"","variation_id":1623,"variation_is_active":true,"variation_is_visible":true,"weight":"","weight_html":"N\/A"},{"attributes":{"attribute_pa_color":"black"},"availability_html":"&lt;p class=\"stock in-stock\"&gt;150 in stock&lt;\/p&gt;\n","backorders_allowed":false,"dimensions":{"length":"","width":"","height":""},"dimensions_html":"N\/A","display_price":80,"display_regular_price":85,"image":{"title":"FF-product-img-3-01","caption":"","url":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","alt":"FF-product-img-3-01","src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","srcset":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png 1000w, https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-293x300.png 293w, https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-768x786.png 768w, https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-50x50.png 50w","sizes":"(max-width: 1000px) 100vw, 1000px","full_src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","full_src_w":1000,"full_src_h":1024,"gallery_thumbnail_src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-100x100.png","gallery_thumbnail_src_w":100,"gallery_thumbnail_src_h":100,"thumb_src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","thumb_src_w":1000,"thumb_src_h":1024,"src_w":1000,"src_h":1024},"image_id":1884,"is_downloadable":false,"is_in_stock":true,"is_purchasable":true,"is_sold_individually":"no","is_virtual":false,"max_qty":150,"min_qty":1,"price_html":"&lt;span class=\"price\"&gt;&lt;span class=\"woocs_price_code\" data-currency=\"\" data-redraw-id=\"67b41b547dc0d\"  data-product-id=\"1624\"&gt;&lt;del aria-hidden=\"true\"&gt;&lt;span class=\"woocommerce-Price-amount amount\"&gt;&lt;bdi&gt;&lt;span class=\"woocommerce-Price-currencySymbol\"&gt;&amp;#36;&lt;\/span&gt;&amp;nbsp;85.00&lt;\/bdi&gt;&lt;\/span&gt;&lt;\/del&gt; &lt;span class=\"screen-reader-text\"&gt;Original price was: &amp;#036;&amp;nbsp;85.00.&lt;\/span&gt;&lt;ins aria-hidden=\"true\"&gt;&lt;span class=\"woocommerce-Price-amount amount\"&gt;&lt;bdi&gt;&lt;span class=\"woocommerce-Price-currencySymbol\"&gt;&amp;#36;&lt;\/span&gt;&amp;nbsp;80.00&lt;\/bdi&gt;&lt;\/span&gt;&lt;\/ins&gt;&lt;span class=\"screen-reader-text\"&gt;Current price is: &amp;#036;&amp;nbsp;80.00.&lt;\/span&gt;&lt;\/span&gt;&lt;\/span&gt;","sku":"","variation_description":"","variation_id":1624,"variation_is_active":true,"variation_is_visible":true,"weight":"","weight_html":"N\/A"},{"attributes":{"attribute_pa_color":"red"},"availability_html":"&lt;p class=\"stock in-stock\"&gt;150 in stock&lt;\/p&gt;\n","backorders_allowed":false,"dimensions":{"length":"","width":"","height":""},"dimensions_html":"N\/A","display_price":70,"display_regular_price":75,"image":{"title":"FF-product-img-3-01","caption":"","url":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","alt":"FF-product-img-3-01","src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","srcset":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png 1000w, https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-293x300.png 293w, https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-768x786.png 768w, https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-50x50.png 50w","sizes":"(max-width: 1000px) 100vw, 1000px","full_src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","full_src_w":1000,"full_src_h":1024,"gallery_thumbnail_src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01-100x100.png","gallery_thumbnail_src_w":100,"gallery_thumbnail_src_h":100,"thumb_src":"https:\/\/furniforma.wpengine.com\/wp-content\/uploads\/2024\/12\/FF-product-img-3-01.png","thumb_src_w":1000,"thumb_src_h":1024,"src_w":1000,"src_h":1024},"image_id":1884,"is_downloadable":false,"is_in_stock":true,"is_purchasable":true,"is_sold_individually":"no","is_virtual":false,"max_qty":150,"min_qty":1,"price_html":"&lt;span class=\"price\"&gt;&lt;span class=\"woocs_price_code\" data-currency=\"\" data-redraw-id=\"67b41b547e64d\"  data-product-id=\"1625\"&gt;&lt;del aria-hidden=\"true\"&gt;&lt;span class=\"woocommerce-Price-amount amount\"&gt;&lt;bdi&gt;&lt;span class=\"woocommerce-Price-currencySymbol\"&gt;&amp;#36;&lt;\/span&gt;&amp;nbsp;75.00&lt;\/bdi&gt;&lt;\/span&gt;&lt;\/del&gt; &lt;span class=\"screen-reader-text\"&gt;Original price was: &amp;#036;&amp;nbsp;75.00.&lt;\/span&gt;&lt;ins aria-hidden=\"true\"&gt;&lt;span class=\"woocommerce-Price-amount amount\"&gt;&lt;bdi&gt;&lt;span class=\"woocommerce-Price-currencySymbol\"&gt;&amp;#36;&lt;\/span&gt;&amp;nbsp;70.00&lt;\/bdi&gt;&lt;\/span&gt;&lt;\/ins&gt;&lt;span class=\"screen-reader-text\"&gt;Current price is: &amp;#036;&amp;nbsp;70.00.&lt;\/span&gt;&lt;\/span&gt;&lt;\/span&gt;","sku":"","variation_description":"","variation_id":1625,"variation_is_active":true,"variation_is_visible":true,"weight":"","weight_html":"N\/A"}]'
                                    >
                                      <div
                                        data-product_id="1621"
                                        data-threshold_min="30"
                                        data-threshold_max="100"
                                        data-total="4"
                                      >
                                        {product?.variantsType?.length > 0 && (
                                          <table
                                            class="variations"
                                            role="presentation"
                                          >
                                            <tbody>
                                              {product?.variantsType?.map(
                                                (items, i) => {
                                                  return (
                                                    <tr key={i}>
                                                      <th class="label">
                                                        <label for="pa_color">
                                                          {items?.name}
                                                        </label>
                                                      </th>
                                                      <td class="value">
                                                        <div
                                                          className=""
                                                          style={{
                                                            gap: 20,
                                                            display: "flex",
                                                          }}
                                                        >
                                                          {items?.variants?.map(
                                                            (subItem, j) => {
                                                              let check;

                                                              if (
                                                                product
                                                                  ?.variantsType
                                                                  ?.length === 3
                                                              ) {
                                                                check =
                                                                  variant?.findIndex(
                                                                    (qw) =>
                                                                      i === 0
                                                                        ? qw?.[
                                                                            `name${
                                                                              i +
                                                                              1
                                                                            }`
                                                                          ] ===
                                                                            subItem?.variant &&
                                                                          qw?.[
                                                                            `name2`
                                                                          ] ===
                                                                            selectedVariantType?.name2 &&
                                                                          qw?.[
                                                                            `name3`
                                                                          ] ===
                                                                            selectedVariantType?.name3
                                                                        : i ===
                                                                          1
                                                                        ? qw?.[
                                                                            `name${
                                                                              i +
                                                                              1
                                                                            }`
                                                                          ] ===
                                                                            subItem?.variant &&
                                                                          qw?.[
                                                                            `name1`
                                                                          ] ===
                                                                            selectedVariantType?.name1 &&
                                                                          qw?.[
                                                                            `name3`
                                                                          ] ===
                                                                            selectedVariantType?.name3
                                                                        : qw?.[
                                                                            `name${
                                                                              i +
                                                                              1
                                                                            }`
                                                                          ] ===
                                                                            subItem?.variant &&
                                                                          qw?.[
                                                                            `name1`
                                                                          ] ===
                                                                            selectedVariantType?.name1 &&
                                                                          qw?.[
                                                                            `name2`
                                                                          ] ===
                                                                            selectedVariantType?.name2
                                                                  );
                                                              } else if (
                                                                product
                                                                  ?.variantsType
                                                                  ?.length === 2
                                                              ) {
                                                                check =
                                                                  variant?.findIndex(
                                                                    (qw) =>
                                                                      i === 0
                                                                        ? qw?.[
                                                                            `name${
                                                                              i +
                                                                              2
                                                                            }`
                                                                          ] ===
                                                                            subItem?.variant &&
                                                                          qw?.[
                                                                            `name3`
                                                                          ] ===
                                                                            selectedVariantType?.name3
                                                                        : qw?.[
                                                                            `name${
                                                                              i +
                                                                              2
                                                                            }`
                                                                          ] ===
                                                                            subItem?.variant &&
                                                                          qw?.[
                                                                            `name1`
                                                                          ] ===
                                                                            selectedVariantType?.name1
                                                                  );
                                                              } else if (
                                                                product
                                                                  ?.variantsType
                                                                  ?.length === 1
                                                              ) {
                                                                check =
                                                                  variant?.findIndex(
                                                                    (qw) =>
                                                                      qw?.[
                                                                        `name${
                                                                          i + 1
                                                                        }`
                                                                      ] ===
                                                                      subItem?.variant
                                                                  );
                                                              }
                                                              if (
                                                                check !== -1
                                                              ) {
                                                                return (
                                                                  <span
                                                                    key={j}
                                                                    onClick={() => {
                                                                      if (
                                                                        product
                                                                          ?.variantsType
                                                                          ?.length ===
                                                                        3
                                                                      ) {
                                                                        setSelectedVariantType(
                                                                          {
                                                                            ...selectedVariantType,
                                                                            [`name${
                                                                              i +
                                                                              1
                                                                            }`]:
                                                                              subItem.variant,
                                                                          }
                                                                        );
                                                                      } else if (
                                                                        product
                                                                          ?.variantsType
                                                                          ?.length ===
                                                                        2
                                                                      ) {
                                                                        setSelectedVariantType(
                                                                          {
                                                                            ...selectedVariantType,
                                                                            [`name${
                                                                              i ===
                                                                              0
                                                                                ? i +
                                                                                  1
                                                                                : i +
                                                                                  2
                                                                            }`]:
                                                                              subItem.variant,
                                                                          }
                                                                        );
                                                                      } else if (
                                                                        product
                                                                          ?.variantsType
                                                                          ?.length ===
                                                                        1
                                                                      ) {
                                                                        setSelectedVariantType(
                                                                          {
                                                                            ...selectedVariantType,
                                                                            [`name${
                                                                              i +
                                                                              1
                                                                            }`]:
                                                                              subItem.variant,
                                                                          }
                                                                        );
                                                                      }
                                                                    }}
                                                                    style={{
                                                                      border:
                                                                        "1px solid black",
                                                                      padding:
                                                                        "2px 5px",
                                                                      borderRadius: 10,
                                                                      cursor:
                                                                        "pointer",
                                                                      backgroundColor:
                                                                        product
                                                                          ?.variantsType
                                                                          ?.length ===
                                                                        3
                                                                          ? selectedVariantType?.[
                                                                              `name${
                                                                                i +
                                                                                1
                                                                              }`
                                                                            ] ===
                                                                            subItem?.variant
                                                                            ? "black"
                                                                            : "white"
                                                                          : product
                                                                              ?.variantsType
                                                                              ?.length ===
                                                                            2
                                                                          ? selectedVariantType?.[
                                                                              `name${
                                                                                i ===
                                                                                0
                                                                                  ? i +
                                                                                    1
                                                                                  : i +
                                                                                    2
                                                                              }`
                                                                            ] ===
                                                                            subItem?.variant
                                                                            ? "black"
                                                                            : "white"
                                                                          : selectedVariantType?.[
                                                                              `name${
                                                                                i +
                                                                                1
                                                                              }`
                                                                            ] ===
                                                                            subItem?.variant
                                                                          ? "black"
                                                                          : "white",
                                                                      color:
                                                                        product
                                                                          ?.variantsType
                                                                          ?.length ===
                                                                        3
                                                                          ? selectedVariantType?.[
                                                                              `name${
                                                                                i +
                                                                                1
                                                                              }`
                                                                            ] ===
                                                                            subItem?.variant
                                                                            ? "white"
                                                                            : "black"
                                                                          : product
                                                                              ?.variantsType
                                                                              ?.length ===
                                                                            2
                                                                          ? selectedVariantType?.[
                                                                              `name${
                                                                                i ===
                                                                                0
                                                                                  ? i +
                                                                                    1
                                                                                  : i +
                                                                                    2
                                                                              }`
                                                                            ] ===
                                                                            subItem?.variant
                                                                            ? "white"
                                                                            : "black"
                                                                          : selectedVariantType?.[
                                                                              `name${
                                                                                i +
                                                                                1
                                                                              }`
                                                                            ] ===
                                                                            subItem?.variant
                                                                          ? "white"
                                                                          : "black",
                                                                    }}
                                                                  >
                                                                    {
                                                                      subItem.variant
                                                                    }
                                                                  </span>
                                                                );
                                                              } else {
                                                                return (
                                                                  <span
                                                                    key={j}
                                                                    style={{
                                                                      border:
                                                                        "1px solid black",
                                                                      padding:
                                                                        "2px 5px",
                                                                      borderRadius: 10,
                                                                      // backgroundColor: "lightgray",
                                                                      // cursor: "not-allowed",
                                                                    }}
                                                                    onClick={() => {
                                                                      if (
                                                                        product
                                                                          ?.variantsType
                                                                          ?.length ===
                                                                        3
                                                                      ) {
                                                                        let findVarient =
                                                                          variant?.find(
                                                                            (
                                                                              er
                                                                            ) =>
                                                                              er[
                                                                                `name${
                                                                                  i +
                                                                                  1
                                                                                }`
                                                                              ] ===
                                                                              subItem.variant
                                                                          );
                                                                        setSelectedVariantType(
                                                                          findVarient
                                                                        );
                                                                      } else if (
                                                                        product
                                                                          ?.variantsType
                                                                          ?.length ===
                                                                        2
                                                                      ) {
                                                                        let findVarient =
                                                                          variant?.find(
                                                                            (
                                                                              er
                                                                            ) =>
                                                                              er[
                                                                                `name${
                                                                                  i ===
                                                                                  0
                                                                                    ? i +
                                                                                      1
                                                                                    : i +
                                                                                      2
                                                                                }`
                                                                              ] ===
                                                                              subItem.variant
                                                                          );
                                                                        setSelectedVariantType(
                                                                          findVarient
                                                                        );
                                                                      } else if (
                                                                        product
                                                                          ?.variantsType
                                                                          ?.length ===
                                                                        1
                                                                      ) {
                                                                        let findVarient =
                                                                          variant?.find(
                                                                            (
                                                                              er
                                                                            ) =>
                                                                              er[
                                                                                `name${
                                                                                  i +
                                                                                  1
                                                                                }`
                                                                              ] ===
                                                                              subItem.variant
                                                                          );
                                                                        setSelectedVariantType(
                                                                          findVarient
                                                                        );
                                                                        setSelectedVariantType(
                                                                          {
                                                                            ...selectedVariantType,
                                                                            [`name${
                                                                              i +
                                                                              1
                                                                            }`]:
                                                                              subItem.variant,
                                                                          }
                                                                        );
                                                                      }
                                                                    }}
                                                                  >
                                                                    {" "}
                                                                    {
                                                                      subItem.variant
                                                                    }
                                                                  </span>
                                                                );
                                                              }
                                                            }
                                                          )}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              )}
                                            </tbody>
                                          </table>
                                        )}
                                        <div class="woocommerce-variation single_variation">
                                          <div class="woocommerce-variation-description"></div>

                                          <div class="woocommerce-variation-availability">
                                            <p class="stock in-stock">
                                              in stock
                                            </p>
                                          </div>
                                        </div>

                                        <div
                                          class="reset_variations_alert screen-reader-text"
                                          role="alert"
                                          aria-live="polite"
                                          aria-relevant="all"
                                        ></div>

                                        <div class="single_variation_wrap">
                                          <div class="woocommerce-variation single_variation"></div>
                                          <div class="woocommerce-variation-add-to-cart variations_button">
                                            <div class="quantity quantity-with-plusminus">
                                              <input
                                                type="button"
                                                value="-"
                                                class="minus"
                                                onClick={() => {
                                                  setQty(+qty - 1);
                                                }}
                                                disabled={qty === 1}
                                              />

                                              <input
                                                type="number"
                                                id="quantity_67b41b547f53e"
                                                class="input-text qty text"
                                                step="1"
                                                max={parseInt(
                                                  product?.maxQuantity
                                                )}
                                                min={parseInt(
                                                  product?.minQuantity || 1
                                                )}
                                                name="quantity"
                                                value={qty}
                                                title="Qty"
                                                placeholder=""
                                                inputmode="numeric"
                                              />

                                              <input
                                                type="button"
                                                onClick={() => {
                                                  setQty(+qty + 1);
                                                }}
                                                value="+"
                                                class="plus"
                                              />
                                            </div>
                                            <button
                                              type="button"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                handleCartBtn(product);
                                              }}
                                              class="single_add_to_cart_button button alt"
                                            >
                                              Add to cart
                                            </button>

                                            <div
                                              class="tinv-wraper woocommerce tinv-wishlist tinvwl-after-add-to-cart tinvwl-woocommerce_after_add_to_cart_button"
                                              data-tinvwl_product_id="1621"
                                            >
                                              <div class="tinv-wishlist-clear"></div>
                                              {wishList?.find(
                                                (er) =>
                                                  er?.productDetails?.id ===
                                                  product?.id
                                              ) ? (
                                                <Link
                                                  to={"/wishlist"}
                                                  role="button"
                                                  tabindex="0"
                                                  class="tinvwl_add_to_wishlist_button tinvwl-icon-heart tinvwl-product-already-on-wishlist tinvwl-position-after tinvwl-product-in-list"
                                                >
                                                  <span class="tinvwl_add_to_wishlist-tex ">
                                                    Go to Wishlist
                                                  </span>
                                                </Link>
                                              ) : (
                                                <Link
                                                  onClick={() => {
                                                    handleWhishListBtn(product);
                                                  }}
                                                  role="button"
                                                  tabindex="0"
                                                  class="tinvwl_add_to_wishlist_button tinvwl-icon-heart tinvwl-product-already-on-wishlist tinvwl-position-after"
                                                >
                                                  <span class="tinvwl_add_to_wishlist-text">
                                                    Add to Wishlist
                                                  </span>
                                                </Link>
                                              )}
                                            </div>

                                            {/* Share Button */}
                                            {/* <button
                                              type="button"
                                              onClick={() => {
                                                if (
                                                  product?.id &&
                                                  product?.name
                                                ) {
                                                  const price =
                                                    selectedVariant?.price
                                                      ? parseFloat(
                                                          selectedVariant?.price
                                                        ) -
                                                        (selectedVariant?.price *
                                                          product?.discountedPercentage) /
                                                          100
                                                      : product?.price;
                                                  DeepLinkHelper.shareProduct(
                                                    product.id,
                                                    product.name,
                                                    price
                                                  );
                                                }
                                              }}
                                              class="tinvwl_add_to_wishlist_button tinvwl-icon-share tinvwl-position-after"
                                              style={{
                                                marginLeft: "10px",
                                                cursor: "pointer",
                                              }}
                                              title="Share this product"
                                            >
                                              <span class="tinvwl_add_to_wishlist-text">
                                                Share Product
                                              </span>
                                            </button> */}

                                            <input
                                              type="hidden"
                                              name="add-to-cart"
                                              value="1621"
                                            />
                                            <input
                                              type="hidden"
                                              name="product_id"
                                              value="1621"
                                            />
                                            <input
                                              type="hidden"
                                              name="variation_id"
                                              class="variation_id"
                                              value="0"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </form>

                                    <div style={{ marginTop: 20 }}>
                                      <div
                                        data-elementor-type="page"
                                        data-elementor-id="2221"
                                        class="elementor elementor-2221"
                                      >
                                        <section
                                          class="custom-table-description elementor-section elementor-top-section elementor-element elementor-element-37337bc elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                                          data-id="37337bc"
                                          data-element_type="section"
                                          data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
                                          dangerouslySetInnerHTML={{
                                            __html: JSON?.parse(
                                              product?.short_desc || "{}"
                                            ),
                                          }}
                                        ></section>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{ marginTop: 20 }}
                          class=" elementor-element elementor-element-158e3c4 start elementor-widget__width-auto wdt-cus-product-check-out-title elementor-widget elementor-widget-wdt-heading"
                          data-id="158e3c4"
                          data-element_type="widget"
                          data-settings='{"item_align":"start","split_heading":"false","title_vertical_align":"center","subtitle_vertical_align":"center","wdt_animation_effect":"none"}'
                          data-widget_type="wdt-heading.default"
                        >
                          <div class="elementor-widget-container">
                            <div
                              class="wdt-heading-holder wdt-heading-wrapper-start"
                              id="wdt-heading-158e3c4"
                            >
                              <h6 class="wdt-heading-title-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                                <span class="wdt-heading-title">
                                  Guaranteed Checkout :
                                </span>
                              </h6>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{ marginTop: 20 }}
                          class="elementor-element elementor-element-370f529 elementor-icon-list--layout-inline elementor-list-item-link-inline wdt-cus-footer-payment-icons elementor-align-left elementor-widget__width-auto elementor-widget elementor-widget-icon-list"
                          data-id="370f529"
                          data-element_type="widget"
                          data-settings='{"wdt_animation_effect":"none"}'
                          data-widget_type="icon-list.default"
                        >
                          <div class="elementor-widget-container">
                            <ul class="elementor-icon-list-items elementor-inline-items">
                              <li class="elementor-icon-list-item elementor-inline-item">
                                <Link>
                                  <span class="elementor-icon-list-icon">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 32"
                                      style={{
                                        enableBackground: " new 0 0 100 32",
                                      }}
                                    >
                                      <path
                                        class="wdt-cus-payment-icon-ap-01"
                                        d="M43.1,19.6c-2.4,1.8-6,2.7-9,2.7c-4.3,0-8.1-1.6-11-4.2c-0.2-0.2,0-0.5,0.3-0.3c3.1,1.8,7,2.9,11,2.9 c2.7,0,5.7-0.6,8.4-1.7C43.1,18.8,43.4,19.3,43.1,19.6z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-ap-01"
                                        d="M44.1,18.4c-0.3-0.4-2.1-0.2-2.8-0.1c-0.2,0-0.3-0.2-0.1-0.3c1.4-1,3.7-0.7,4-0.4c0.3,0.3-0.1,2.6-1.4,3.7 c-0.2,0.2-0.4,0.1-0.3-0.1C43.7,20.5,44.4,18.8,44.1,18.4L44.1,18.4z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-ap-02"
                                        d="M41.3,11.1v-0.9c0-0.1,0.1-0.2,0.2-0.2h4.3c0.1,0,0.2,0.1,0.2,0.2v0.8c0,0.1-0.1,0.3-0.3,0.6l-2.2,3.2 c0.8,0,1.7,0.1,2.4,0.5c0.2,0.1,0.2,0.2,0.2,0.4v1c0,0.1-0.2,0.3-0.3,0.2c-1.3-0.7-3.1-0.8-4.5,0c-0.2,0.1-0.3-0.1-0.3-0.2v-1 c0-0.2,0-0.4,0.2-0.7l2.6-3.7h-2.2C41.4,11.3,41.3,11.2,41.3,11.1L41.3,11.1z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-ap-02"
                                        d="M25.7,17h-1.3c-0.1,0-0.2-0.1-0.2-0.2v-6.7c0-0.1,0.1-0.2,0.3-0.2h1.2c0.1,0,0.2,0.1,0.2,0.2V11h0 c0.3-0.9,0.9-1.2,1.7-1.2s1.3,0.4,1.7,1.2c0.3-0.9,1-1.2,1.8-1.2c0.6,0,1.1,0.2,1.5,0.7c0.4,0.6,0.3,1.4,0.3,2.1v4.2 c0,0.1-0.1,0.2-0.3,0.2h-1.3c-0.1,0-0.2-0.1-0.2-0.2v-3.5c0-0.3,0-1,0-1.2c-0.1-0.5-0.4-0.6-0.8-0.6c-0.3,0-0.6,0.2-0.8,0.6 c-0.1,0.3-0.1,0.9-0.1,1.3v3.5c0,0.1-0.1,0.2-0.3,0.2h-1.3c-0.1,0-0.2-0.1-0.2-0.2v-3.5c0-0.8,0.1-1.8-0.8-1.8 c-0.9,0-0.9,1.1-0.9,1.8v3.5C25.9,17,25.8,17.1,25.7,17L25.7,17z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-ap-02"
                                        d="M49.7,11.1c-0.9,0-1,1.3-1,2.1c0,0.8,0,2.6,1,2.6c1,0,1-1.4,1-2.3c0-0.6,0-1.2-0.2-1.8 C50.4,11.3,50.1,11.1,49.7,11.1z M49.7,9.8c1.9,0,3,1.7,3,3.8c0,2.1-1.1,3.6-3,3.6c-1.8,0-2.9-1.7-2.9-3.7 C46.8,11.4,47.8,9.7,49.7,9.8L49.7,9.8z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-ap-02"
                                        d="M55.2,17h-1.3c-0.1,0-0.2-0.1-0.2-0.2v-6.7c0-0.1,0.1-0.2,0.3-0.2h1.2c0.1,0,0.2,0.1,0.2,0.2v1h0 c0.4-0.9,0.9-1.3,1.8-1.3c0.6,0,1.1,0.2,1.5,0.8C59,11.1,59,12,59,12.6v4.2c0,0.1-0.1,0.2-0.3,0.2h-1.3c-0.1,0-0.2-0.1-0.2-0.2v-3.6 c0-0.7,0.1-1.8-0.8-1.8c-0.3,0-0.6,0.2-0.8,0.5c-0.2,0.4-0.2,0.8-0.2,1.3v3.6C55.4,16.9,55.3,17,55.2,17z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-ap-02"
                                        d="M40.2,15.8c-0.2-0.3-0.5-0.6-0.5-1.2v-2c0-0.9,0.1-1.6-0.6-2.2c-0.5-0.5-1.3-0.7-1.9-0.7h-0.1 c-1.2,0-2.6,0.5-2.8,2c0,0.2,0.1,0.3,0.2,0.3l1.3,0.1c0.1,0,0.2-0.1,0.2-0.2c0.1-0.5,0.6-0.8,1-0.8c0.3,0,0.6,0.1,0.7,0.3 c0.2,0.3,0.2,0.6,0.2,0.9v0.2c-0.8,0.1-1.7,0.1-2.4,0.5c-0.8,0.3-1.4,1.1-1.4,2.1c0,1.3,0.9,2,1.9,2c0.9,0,1.4-0.2,2.1-0.9 c0.2,0.3,0.3,0.5,0.8,0.9c0.1,0,0.3,0,0.3,0l0,0c0.3-0.2,0.7-0.7,1-0.9C40.3,16,40.3,15.9,40.2,15.8z M37.9,13.8L37.9,13.8 c0,0.5,0,0.9-0.3,1.4c-0.2,0.4-0.5,0.6-0.9,0.6c-0.5,0-0.8-0.4-0.8-0.9c0-1.1,1-1.3,1.9-1.3V13.8z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-ap-02"
                                        d="M23.1,15.8c-0.2-0.3-0.5-0.6-0.5-1.2v-2c0-0.9,0.1-1.6-0.6-2.2c-0.5-0.5-1.3-0.7-1.9-0.7H20 c-1.2,0-2.6,0.5-2.8,2c0,0.2,0.1,0.3,0.2,0.3l1.3,0.1c0.1,0,0.2-0.1,0.2-0.2c0.1-0.5,0.6-0.8,1-0.8c0.3,0,0.6,0.1,0.7,0.3 c0.2,0.3,0.2,0.6,0.2,0.9v0.2c-0.8,0.1-1.7,0.1-2.4,0.5c-0.8,0.3-1.4,1.1-1.4,2.1c0,1.3,0.9,2,1.9,2c0.9,0,1.4-0.2,2.1-0.9 c0.2,0.3,0.3,0.5,0.8,0.9c0.1,0,0.3,0,0.3,0v0c0.3-0.2,0.7-0.7,1-0.9C23.2,16,23.2,15.9,23.1,15.8z M20.9,13.8L20.9,13.8 c0,0.5,0,0.9-0.3,1.4c-0.2,0.4-0.5,0.6-0.9,0.6c-0.5,0-0.8-0.4-0.8-0.9c0-1.1,1-1.3,1.9-1.3V13.8z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-ap-02"
                                        d="M76.7,19.4v-0.5c0-0.1,0.1-0.2,0.2-0.2c0.3,0,0.7,0.1,0.9,0c0.4-0.1,0.6-0.3,0.8-0.7c0.2-0.5,0.4-0.9,0.4-1.1 l-2.7-6.7c0-0.1-0.1-0.3,0.2-0.3h0.9c0.2,0,0.3,0.1,0.3,0.2l2,5.4l1.9-5.4c0-0.1,0.1-0.2,0.3-0.2h0.9c0.2,0,0.2,0.2,0.2,0.3 l-2.7,6.9c-0.4,0.9-0.8,2.4-1.9,2.6c-0.5,0.1-1.2,0.1-1.6-0.1C76.8,19.6,76.7,19.5,76.7,19.4L76.7,19.4z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-ap-02"
                                        d="M75.5,16.6c0,0.1-0.1,0.2-0.2,0.2h-0.7c-0.1,0-0.2-0.1-0.3-0.2l-0.1-0.5c-0.3,0.3-0.7,0.5-1.1,0.7 c-0.8,0.3-1.7,0.4-2.5-0.1c-0.6-0.3-0.9-1-0.9-1.7c0-0.5,0.2-1,0.5-1.4c0.5-0.5,1.2-0.8,2-0.8c0.5,0,1.2,0.1,1.8,0.2v-0.9 c0-0.9-0.4-1.3-1.4-1.3c-0.8,0-1.4,0.1-2.2,0.4c-0.1,0-0.2-0.1-0.2-0.2v-0.5c0-0.1,0.1-0.2,0.2-0.3c0.6-0.3,1.4-0.4,2.4-0.5 c1.2,0,2.6,0.3,2.6,2.1L75.5,16.6L75.5,16.6z M74.2,15.3v-1.4c-0.5-0.1-1.2-0.2-1.5-0.2c-0.5,0-0.9,0.1-1.2,0.4 c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.4,0.1,0.7,0.4,0.9C72,16,72.5,16,73,15.9C73.5,15.7,74,15.5,74.2,15.3L74.2,15.3z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-ap-02"
                                        d="M66.1,9.7c-0.8,0-1.6,0.4-2.3,0.9l-0.1-0.5c0-0.1-0.1-0.2-0.3-0.2h-0.7c-0.1,0-0.2,0.1-0.2,0.2v9.3 c0,0.1,0.1,0.2,0.2,0.2h0.9l0,0c0.1,0,0.2-0.1,0.2-0.2v-3.2c0.6,0.5,1.3,0.8,2.1,0.8c1.9,0,3-1.6,3-3.6C69,11.5,68.3,9.7,66.1,9.7z  M66.9,15.5c-0.4,0.3-0.7,0.4-1.3,0.4c-0.5,0-1.2-0.3-1.7-0.7v-3.8c0.5-0.4,1.2-0.6,1.8-0.6c1.5,0,1.9,1.2,1.9,2.5 C67.5,14.2,67.4,15,66.9,15.5z"
                                      ></path>
                                    </svg>
                                  </span>
                                  <span class="elementor-icon-list-text"></span>
                                </Link>
                              </li>
                              <li class="elementor-icon-list-item elementor-inline-item">
                                <Link>
                                  <span class="elementor-icon-list-icon">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 32"
                                      style={{
                                        enableBackground: " new 0 0 100 32",
                                      }}
                                    >
                                      <path
                                        class="wdt-cus-payment-icon-gp-0"
                                        d="M48.4,7.6v6h3.7c0.9,0,1.6-0.3,2.2-0.9c0.6-0.6,0.9-1.3,0.9-2.1s-0.3-1.5-0.9-2.1c-0.6-0.6-1.3-0.9-2.2-0.9 H48.4L48.4,7.6z M48.4,15.7v7h-2.2V5.5H52c1.5,0,2.8,0.5,3.8,1.5c1.1,1,1.6,2.2,1.6,3.6s-0.5,2.7-1.6,3.6c-1,1-2.3,1.5-3.8,1.5 L48.4,15.7L48.4,15.7z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-gp-0"
                                        d="M59.7,19.1c0,0.6,0.3,1.1,0.7,1.4s1.1,0.6,1.7,0.6c0.9,0,1.8-0.4,2.5-1c0.7-0.7,1.1-1.5,1.1-2.4 c-0.7-0.5-1.7-0.8-2.9-0.8c-0.9,0-1.7,0.2-2.2,0.6C60,17.9,59.7,18.5,59.7,19.1L59.7,19.1z M62.5,10.5c1.6,0,2.9,0.4,3.9,1.3 c1,0.9,1.4,2.1,1.4,3.6v7.3h-2.1V21h-0.1c-0.9,1.3-2.1,2-3.7,2c-1.3,0-2.4-0.4-3.3-1.2c-0.9-0.8-1.3-1.7-1.3-2.9 c0-1.2,0.5-2.2,1.4-2.9c0.9-0.7,2.2-1.1,3.7-1.1c1.3,0,2.4,0.2,3.3,0.7v-0.5c0-0.8-0.3-1.4-0.9-2c-0.6-0.5-1.3-0.8-2.1-0.8 c-1.2,0-2.2,0.5-2.9,1.6l-2-1.2C58.8,11.3,60.4,10.5,62.5,10.5L62.5,10.5z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-gp-0"
                                        d="M80,10.9l-7.4,17h-2.3l2.8-6l-4.9-11h2.4l3.5,8.5h0.1l3.4-8.5H80z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-gp-1"
                                        d="M39.4,14.2c0-0.7-0.1-1.4-0.2-2h-9.3V16h5.3c-0.2,1.2-0.9,2.3-2,3v2.5h3.2C38.4,19.8,39.4,17.2,39.4,14.2z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-gp-2"
                                        d="M29.9,23.9c2.7,0,4.9-0.9,6.6-2.4L33.3,19c-0.9,0.6-2,1-3.4,1c-2.6,0-4.8-1.7-5.6-4.1H21v2.6 C22.7,21.7,26,23.9,29.9,23.9L29.9,23.9z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-gp-3"
                                        d="M24.4,15.9C24.2,15.3,24,14.7,24,14s0.1-1.3,0.3-1.9V9.6H21c-0.6,1.3-1,2.8-1,4.4s0.4,3.1,1.1,4.4L24.4,15.9z"
                                      ></path>
                                      <path
                                        class="wdt-cus-payment-icon-gp-4"
                                        d="M29.9,8c1.5,0,2.8,0.5,3.8,1.5l2.8-2.8c-1.7-1.6-4-2.6-6.6-2.6c-3.9,0-7.2,2.2-8.9,5.5l3.3,2.6 C25.1,9.8,27.3,8,29.9,8L29.9,8z"
                                      ></path>
                                    </svg>
                                  </span>
                                  <span class="elementor-icon-list-text"></span>
                                </Link>
                              </li>

                              <li class="elementor-icon-list-item elementor-inline-item">
                                <Link>
                                  <span class="elementor-icon-list-icon">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 32"
                                      style={{
                                        enableBackground: " new 0 0 100 32",
                                      }}
                                    >
                                      <path
                                        class="wdt-cus-master-02-01"
                                        d="M50,24.5c2,1.9,4.7,3,7.7,3c6.4,0,11.5-5.1,11.5-11.5c0-6.4-5.1-11.5-11.5-11.5c-3,0-5.7,1.1-7.7,3 c-2.3,2.1-3.8,5.1-3.8,8.5S47.7,22.4,50,24.5z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-01"
                                        d="M67.6,22.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4C67.8,22.8,67.6,22.6,67.6,22.4z  M68,22.7c0.1,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3C67.7,22.5,67.9,22.7,68,22.7z M68,22.6L68,22.6 l-0.1-0.3H68c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1c0,0,0,0.1-0.1,0.1l0.1,0.2h-0.1l0-0.1H68L68,22.6L68,22.6z M68,22.4L68,22.4 c0.1,0,0.1,0,0.1,0C68.1,22.3,68.1,22.3,68,22.4L68,22.4L68,22.4z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-02"
                                        d="M53.7,14.8c0-0.4-0.1-0.8-0.2-1.2h-7c0.1-0.4,0.2-0.8,0.3-1.2h6.4c-0.1-0.4-0.3-0.8-0.5-1.2h-5.4 c0.2-0.4,0.4-0.8,0.7-1.2H52c-0.2-0.4-0.5-0.8-0.9-1.2h-2.3c0.3-0.4,0.8-0.8,1.1-1.2c-2-1.9-4.7-3-7.7-3c-6.4,0-11.5,5.2-11.5,11.5 c0,6.3,5.1,11.5,11.5,11.5c3,0,5.7-1.1,7.7-3c0.4-0.4,0.8-0.8,1.2-1.2h-2.3c-0.3-0.4-0.6-0.8-0.9-1.2H52c0.2-0.4,0.5-0.8,0.7-1.2 h-5.4c-0.2-0.4-0.3-0.8-0.5-1.2h6.4c0.1-0.4,0.2-0.8,0.3-1.2c0.1-0.4,0.2-0.8,0.2-1.2c0-0.4,0.1-0.8,0.1-1.2 C53.8,15.7,53.8,15.2,53.7,14.8L53.7,14.8z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-03"
                                        d="M67.6,18.6c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4S68.2,19,68,19C67.8,19,67.6,18.8,67.6,18.6z M68,18.9 c0.1,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3C67.7,18.8,67.9,18.9,68,18.9z M68,18.8L68,18.8l-0.1-0.3H68 c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1c0,0,0,0.1-0.1,0.1l0.1,0.2h-0.1l0-0.1H68L68,18.8L68,18.8z M68,18.6L68,18.6c0.1,0,0.1,0,0.1,0 C68.1,18.6,68.1,18.6,68,18.6L68,18.6L68,18.6z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-04"
                                        d="M46.1,19.3c-0.4,0.1-0.7,0.2-0.9,0.2c-0.6,0-0.9-0.4-0.9-1c0-0.1,0-0.3,0-0.4l0.1-0.4l0.1-0.4l0.5-3.2h1.2 L46,14.6h0.8l-0.2,1.2h-0.8l-0.3,1.9c0,0,0,0.1,0,0.2c0,0.2,0.1,0.4,0.4,0.4c0.2,0,0.2,0,0.4,0L46.1,19.3L46.1,19.3z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-04"
                                        d="M49.9,19.2c-0.4,0.1-0.9,0.2-1.3,0.2c-1.3,0-2.1-0.7-2.1-2.1c0-1.6,0.9-2.8,2.2-2.8c1,0,1.7,0.7,1.7,1.7 c0,0.3,0,0.7-0.2,1.2h-2.5v0.1c0,0.6,0.4,0.8,1.1,0.8c0.4,0,0.9-0.1,1.3-0.3L49.9,19.2L49.9,19.2z M49.2,16.4v-0.2 c0-0.4-0.2-0.6-0.6-0.6c-0.4,0-0.7,0.3-0.8,0.8L49.2,16.4L49.2,16.4z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-04"
                                        d="M36.6,19.4h-1.2l0.7-4.5l-1.6,4.5h-0.9l-0.1-4.5l-0.8,4.5h-1.2l1-5.8h1.8l0.1,3.6l1.2-3.6h2L36.6,19.4z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-04"
                                        d="M39.6,17.2c-0.1,0-0.2,0-0.2,0c-0.7,0-1.1,0.3-1.1,0.7c0,0.3,0.2,0.5,0.4,0.5C39.3,18.4,39.5,17.9,39.6,17.2z  M40.6,19.4h-1.1v-0.5c-0.2,0.4-0.6,0.6-1.3,0.6c-0.6,0-1.1-0.5-1.1-1.3c0-0.2,0-0.4,0.1-0.6c0.2-0.8,0.9-1.2,2.1-1.2 c0.1,0,0.4,0,0.5,0c0-0.2,0-0.2,0-0.3c0-0.3-0.2-0.4-0.8-0.4c-0.4,0-0.8,0.1-1,0.1l-0.2,0.1h-0.1l0.2-1.1c0.6-0.2,1-0.2,1.4-0.2 c1.1,0,1.6,0.5,1.6,1.4c0,0.2,0,0.4-0.1,0.9l-0.2,1.7l0,0.3l0,0.2L40.6,19.4L40.6,19.4L40.6,19.4z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-04"
                                        d="M55.9,14.7c0.3,0,0.7,0.1,1.1,0.3l0.2-1.3c-0.1,0-0.1,0-0.3-0.1l-0.5-0.1c-0.2,0-0.3-0.1-0.6-0.1 c-0.6,0-1,0-1.3,0.2c-0.2,0.1-0.4,0.3-0.8,0.6l-0.1,0l-1.3,0.9l0.1-0.5h-1.3l-0.8,4.7h1.2l0.4-2.5c0,0,0.2-0.4,0.3-0.5 c0.2-0.3,0.4-0.3,0.7-0.3H53c0,0.3,0,0.6,0,0.9c0,1.5,0.9,2.5,2.2,2.5c0.3,0,0.6,0,1.1-0.2l0.2-1.3c-0.4,0.2-0.8,0.3-1.1,0.3 c-0.7,0-1.1-0.5-1.1-1.4C54.3,15.6,55,14.7,55.9,14.7L55.9,14.7z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-04"
                                        d="M66.5,13.5l-0.3,1.7c-0.3-0.4-0.7-0.7-1.1-0.7c-0.7,0-1.3,0.4-1.6,1.1l-0.8-0.5l0.1-0.5h-1.3l-0.8,4.7h1.3 l0.4-2.5c0,0,0.3-0.4,0.4-0.5c0.2-0.2,0.4-0.3,0.5-0.3c-0.1,0.4-0.2,0.9-0.2,1.4c0,1.2,0.6,2,1.5,2c0.4,0,0.8-0.2,1.1-0.5l-0.1,0.5 h1.2l0.9-5.8H66.5L66.5,13.5z M64.9,18.2c-0.4,0-0.6-0.3-0.6-0.9c0-0.9,0.4-1.6,1-1.6c0.4,0,0.7,0.3,0.7,0.9 C65.9,17.6,65.5,18.2,64.9,18.2L64.9,18.2z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-04"
                                        d="M59.2,17.2c-0.1,0-0.2,0-0.2,0c-0.7,0-1.1,0.3-1.1,0.7c0,0.3,0.2,0.5,0.4,0.5C59,18.4,59.2,17.9,59.2,17.2z  M60.2,19.4h-1.1v-0.5c-0.2,0.4-0.6,0.6-1.3,0.6c-0.6,0-1.1-0.5-1.1-1.3c0-1.1,0.9-1.8,2.2-1.8c0.1,0,0.4,0,0.5,0c0-0.2,0-0.2,0-0.3 c0-0.3-0.2-0.4-0.8-0.4c-0.4,0-0.8,0.1-1,0.1l-0.2,0.1h-0.1l0.2-1.1c0.6-0.2,1-0.2,1.4-0.2c1.1,0,1.6,0.5,1.6,1.4 c0,0.2,0,0.4-0.1,0.9l-0.2,1.7l0,0.3l0,0.2v0.2L60.2,19.4L60.2,19.4z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-04"
                                        d="M43.1,15.6c0.2,0,0.6,0,0.9,0.1l0.2-1.1c-0.4,0-0.8-0.1-1.1-0.1c-1.4,0-1.9,0.8-1.9,1.6c0,0.6,0.3,1,0.9,1.3 c0.5,0.2,0.6,0.3,0.6,0.5c0,0.3-0.3,0.5-0.8,0.5c-0.4,0-0.7-0.1-1.1-0.2l-0.1,1.1h0l0.2,0c0,0,0.2,0,0.3,0c0.3,0,0.6,0,0.7,0 c1.4,0,2-0.5,2-1.6c0-0.7-0.3-1-0.9-1.3c-0.5-0.2-0.6-0.3-0.6-0.5S42.8,15.7,43.1,15.6L43.1,15.6z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-03"
                                        d="M57.6,13.4l-0.2,1.3c-0.4-0.2-0.8-0.3-1.1-0.3c-0.9,0-1.6,0.9-1.6,2.2c0,0.9,0.4,1.4,1.2,1.4 c0.3,0,0.7-0.1,1.1-0.3l-0.2,1.3c-0.4,0.1-0.8,0.2-1.1,0.2c-1.3,0-2.2-0.9-2.2-2.5c0-2.1,1.1-3.5,2.8-3.5c0.2,0,0.4,0,0.6,0l0.5,0.1 C57.4,13.3,57.5,13.3,57.6,13.4z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-03"
                                        d="M53.6,14.2c0,0-0.1,0-0.1,0c-0.4,0-0.6,0.2-1,0.8l0.1-0.7h-1.1L50.6,19h1.2c0.4-2.9,0.6-3.4,1.2-3.4h0.1 C53.3,15,53.4,14.6,53.6,14.2L53.6,14.2L53.6,14.2z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-03"
                                        d="M46.4,18.9c-0.3,0.1-0.6,0.2-0.9,0.2c-0.6,0-1-0.4-1-1c0-0.1,0-0.3,0-0.4l0.1-0.5l0.1-0.4l0.5-3.2h1.2l-0.1,0.7 h0.6l-0.2,1.2h-0.6l-0.3,2c0,0.1,0,0.2,0,0.2c0,0.2,0.1,0.4,0.4,0.4c0.2,0,0.2,0,0.3,0L46.4,18.9L46.4,18.9z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-03"
                                        d="M41.6,15.8c0,0.6,0.3,1,0.9,1.3c0.5,0.2,0.6,0.3,0.6,0.5c0,0.3-0.2,0.4-0.7,0.4c-0.4,0-0.7-0.1-1.1-0.2 l-0.2,1.1h0.1l0.2,0c0,0,0.2,0,0.3,0c0.3,0,0.5,0,0.7,0c1.3,0,1.9-0.5,1.9-1.6c0-0.7-0.2-1-0.9-1.3c-0.5-0.2-0.6-0.3-0.6-0.5 c0-0.3,0.2-0.4,0.6-0.4c0.2,0,0.6,0,0.9,0.1l0.2-1.1c-0.3,0-0.8-0.1-1.1-0.1C42.1,14.2,41.6,14.9,41.6,15.8L41.6,15.8z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-03"
                                        d="M67.1,19h-1.2l0.1-0.5c-0.3,0.4-0.7,0.5-1.1,0.5c-0.9,0-1.5-0.8-1.5-2c0-1.6,0.9-2.9,2-2.9 c0.5,0,0.9,0.2,1.2,0.7l0.3-1.7H68L67.1,19L67.1,19z M65.3,17.9c0.6,0,1-0.7,1-1.6c0-0.6-0.2-0.9-0.7-0.9c-0.6,0-1,0.7-1,1.6 C64.6,17.6,64.8,17.9,65.3,17.9z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-03"
                                        d="M50.2,18.9c-0.4,0.1-0.8,0.2-1.3,0.2c-1.4,0-2.1-0.8-2.1-2.1c0-1.6,0.9-2.8,2.2-2.8c1,0,1.7,0.7,1.7,1.7 c0,0.3,0,0.7-0.1,1.2h-2.5c0,0,0,0.1,0,0.1c0,0.5,0.4,0.8,1.1,0.8c0.4,0,0.8-0.1,1.3-0.3L50.2,18.9L50.2,18.9z M49.5,16.1v-0.2 c0-0.4-0.2-0.6-0.6-0.6s-0.7,0.3-0.8,0.9H49.5L49.5,16.1z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-03"
                                        d="M36.9,19h-1.2l0.7-4.5L34.8,19h-0.9l-0.1-4.5L33.1,19h-1.1l1-5.8h1.8l0.1,3.6l1.2-3.6h1.9L36.9,19z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-03"
                                        d="M40,16.9c-0.1,0-0.2,0-0.3,0c-0.7,0-1.1,0.2-1.1,0.7c0,0.3,0.2,0.5,0.4,0.5C39.6,18.1,39.9,17.6,40,16.9z  M40.9,19h-1v-0.5c-0.3,0.4-0.7,0.6-1.3,0.6c-0.7,0-1.1-0.5-1.1-1.3c0-1.1,0.8-1.8,2.2-1.8c0.1,0,0.3,0,0.5,0c0-0.1,0-0.2,0-0.3 c0-0.3-0.2-0.4-0.8-0.4c-0.4,0-0.8,0-1,0.1l-0.2,0H38l0.2-1c0.6-0.2,1-0.2,1.5-0.2c1.1,0,1.6,0.5,1.6,1.4c0,0.2,0,0.4-0.1,0.9 L41,18.2l0,0.3v0.2l0,0.2L40.9,19L40.9,19z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-03"
                                        d="M59.6,16.9c-0.1,0-0.2,0-0.3,0c-0.7,0-1.1,0.2-1.1,0.7c0,0.3,0.2,0.5,0.4,0.5C59.2,18.1,59.6,17.6,59.6,16.9z  M60.5,19h-1v-0.5c-0.3,0.4-0.7,0.6-1.3,0.6c-0.7,0-1.1-0.5-1.1-1.3c0-1.1,0.8-1.8,2.2-1.8c0.1,0,0.3,0,0.5,0c0-0.1,0-0.2,0-0.3 c0-0.3-0.2-0.4-0.8-0.4c-0.4,0-0.8,0-1,0.1l-0.2,0h-0.1l0.2-1c0.6-0.2,1-0.2,1.5-0.2c1.1,0,1.6,0.5,1.6,1.4c0,0.2,0,0.4-0.1,0.9 l-0.2,1.7l0,0.3l0,0.2v0.2L60.5,19z"
                                      ></path>
                                      <path
                                        class="wdt-cus-master-02-03"
                                        d="M63.8,14.2c0,0-0.1,0-0.1,0c-0.4,0-0.7,0.2-1,0.8l0.1-0.7h-1.1L60.9,19h1.3c0.4-2.9,0.6-3.4,1.1-3.4h0.1 C63.5,15,63.7,14.6,63.8,14.2L63.8,14.2L63.8,14.2z"
                                      ></path>
                                    </svg>
                                  </span>
                                  <span class="elementor-icon-list-text"></span>
                                </Link>
                              </li>
                              <li class="elementor-icon-list-item elementor-inline-item">
                                <Link>
                                  <span class="elementor-icon-list-icon">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 32"
                                      style={{
                                        enableBackground: " new 0 0 100 32",
                                      }}
                                    >
                                      <path
                                        class="wdt-cus-visa-02-01"
                                        d="M45.3,27.1h-5.8l3.6-22.2h5.8L45.3,27.1z"
                                      ></path>
                                      <path
                                        class="wdt-cus-visa-02-01"
                                        d="M34.7,4.9l-5.5,15.3l-0.6-3.3l-1.9-10c0,0-0.2-2-2.7-2h-9.1l-0.1,0.4c0,0,2.8,0.6,6.1,2.5l5,19.3h6l9.2-22.2 H34.7z"
                                      ></path>
                                      <path
                                        class="wdt-cus-visa-02-01"
                                        d="M80.1,27.1h5.3L80.8,4.9h-4.6c-2.1,0-2.7,1.7-2.7,1.7l-8.6,20.5h6l1.2-3.3h7.4L80.1,27.1L80.1,27.1z M73.8,19.3 l3-8.3l1.7,8.3H73.8L73.8,19.3z"
                                      ></path>
                                      <path
                                        class="wdt-cus-visa-02-01"
                                        d="M65.3,10.2l0.8-4.8c0,0-2.5-1-5.2-1c-2.9,0-9.7,1.3-9.7,7.4c0,5.7,8,5.8,8,8.8c0,3-7.2,2.5-9.5,0.6l-0.9,5 c0,0,2.6,1.3,6.5,1.3s9.9-2,9.9-7.6s-8.1-6.3-8.1-8.8S62.8,8.9,65.3,10.2L65.3,10.2z"
                                      ></path>
                                      <path
                                        class="wdt-cus-visa-02-02"
                                        d="M28.5,16.9l-1.9-10c0,0-0.2-2-2.8-2h-9.1l-0.1,0.6c0,0,4.4,0.7,8.6,4.1C27.2,12.8,28.5,16.9,28.5,16.9 L28.5,16.9z"
                                      ></path>
                                    </svg>
                                  </span>
                                  <span class="elementor-icon-list-text"></span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  style={{ padding: 0 }}
                  class="custom-slider-home-2  elementor-section elementor-top-section elementor-element elementor-element-906c020 elementor-section-boxed elementor-section-height-default elementor-section-height-default "
                  data-id="906c020"
                  data-element_type="section"
                  data-settings='{"animation":"fadeInUp","animation_delay":200,"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
                >
                  <div class="elementor-container elementor-column-gap-no">
                    <div
                      class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ee7f4b1"
                      data-id="ee7f4b1"
                      data-element_type="column"
                    >
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div
                          class="elementor-element elementor-element-68caae2 elementor-widget elementor-widget-wdt-shop-product-single-tabs"
                          data-id="68caae2"
                          data-element_type="widget"
                          data-settings='{"wdt_animation_effect":"none"}'
                          data-widget_type="wdt-shop-product-single-tabs.default"
                        >
                          <div class="elementor-widget-container">
                            <div class="wdt-product-tabs-wrapper">
                              <div class="wdt-product-tabs">
                                <div class="woocommerce-tabs wc-tabs-wrapper">
                                  <ul class="tabs wc-tabs" role="tablist">
                                    {product.long_desc?.length > 3 && (
                                      <li
                                        class={`${
                                          tab === "description" ? "active" : ""
                                        } description_tab"`}
                                        id="tab-title-description"
                                        role="tab"
                                        aria-controls="tab-description"
                                        onClick={() => {
                                          setTab("description");
                                        }}
                                      >
                                        <Link to={""}> Description </Link>
                                      </li>
                                    )}
                                    {product?.add_info?.length > 0 && (
                                      <li
                                        class={`${
                                          tab === "additionalInformation"
                                            ? "active"
                                            : ""
                                        } additional_information_tab"`}
                                        id="tab-title-additional_information"
                                        role="tab"
                                        aria-controls="tab-additional_information"
                                        onClick={() => {
                                          setTab("additionalInformation");
                                        }}
                                      >
                                        <Link to={""}>
                                          Additional information
                                        </Link>
                                      </li>
                                    )}
                                    <li
                                      class={`${
                                        tab === "shippingReviews"
                                          ? "active"
                                          : ""
                                      } furniforma_materialcare_tab"`}
                                      id="tab-title-furniforma_materialcare"
                                      role="tab"
                                      aria-controls="tab-furniforma_materialcare"
                                      onClick={() => {
                                        setTab("shippingReviews");
                                      }}
                                    >
                                      <Link to={""}>Shipping & Returns</Link>
                                    </li>
                                    <li
                                      class={`${
                                        tab === "reviews" ? "active" : ""
                                      } reviews_tab"`}
                                      id="tab-title-reviews"
                                      role="tab"
                                      aria-controls="tab-reviews"
                                      onClick={() => {
                                        setTab("reviews");
                                      }}
                                    >
                                      <Link to={""}>
                                        {" "}
                                        Reviews (
                                        {product?.averageRatingsDetails?.length}
                                        ){" "}
                                      </Link>
                                    </li>
                                  </ul>
                                  {tab === "description" && (
                                    <div
                                      class="woocommerce-Tabs-panel woocommerce-Tabs-panel--description panel entry-content wc-tab"
                                      id="tab-description"
                                      role="tabpanel"
                                      aria-labelledby="tab-title-description"
                                    >
                                      <h2>Description</h2>

                                      <div
                                        data-elementor-type="page"
                                        data-elementor-id="2221"
                                        class="elementor elementor-2221"
                                      >
                                        <section
                                          class="custom-table-description elementor-section elementor-top-section elementor-element elementor-element-37337bc elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                                          data-id="37337bc"
                                          data-element_type="section"
                                          data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
                                          dangerouslySetInnerHTML={{
                                            __html: JSON?.parse(
                                              product?.long_desc || "{}"
                                            ),
                                          }}
                                        ></section>
                                      </div>
                                    </div>
                                  )}
                                  {tab === "additionalInformation" &&
                                    product?.add_info?.length > 0 && (
                                      <div
                                        class="custom-table-description woocommerce-Tabs-panel woocommerce-Tabs-panel--additional_information panel entry-content wc-tab"
                                        id="tab-additional_information"
                                        role="tabpanel"
                                        aria-labelledby="tab-title-additional_information"
                                      >
                                        <h2>Additional information</h2>

                                        <table
                                          class="custom-table-description woocommerce-product-attributes shop_attributes"
                                          aria-label="Product Details"
                                        >
                                          {product?.add_info?.map((item, i) => (
                                            <tr
                                              key={i}
                                              class="woocommerce-product-attributes-item woocommerce-product-attributes-item--attribute_primary-material"
                                            >
                                              <th
                                                class="woocommerce-product-attributes-item__label"
                                                scope="row"
                                              >
                                                {item?.title}
                                              </th>
                                              <td class="woocommerce-product-attributes-item__value">
                                                <p>{item?.value}</p>
                                              </td>
                                            </tr>
                                          ))}
                                        </table>
                                      </div>
                                    )}
                                  {tab === "reviews" && (
                                    <div
                                      class="woocommerce-Tabs-panel woocommerce-Tabs-panel--reviews panel entry-content wc-tab"
                                      id="tab-reviews"
                                      role="tabpanel"
                                      aria-labelledby="tab-title-reviews"
                                    >
                                      <div
                                        id="reviews"
                                        class="woocommerce-Reviews"
                                      >
                                        <div id="comments">
                                          <div
                                            className=""
                                            style={{
                                              display: "flex",
                                              justifyContent: "end",
                                              width: "100%",
                                              marginBottom: 20,
                                            }}
                                          >
                                            <button
                                              onClick={() => {
                                                setAddReviewModal(true);
                                              }}
                                              class=" button alt"
                                            >
                                              Add Review
                                            </button>
                                          </div>
                                          <ol class="commentlist">
                                            {product?.userRatingsDetails?.map(
                                              (item, i) => (
                                                <li
                                                  key={i}
                                                  class="review byuser comment-author-developer bypostauthor even thread-even depth-1"
                                                  id="li-comment-66"
                                                >
                                                  <div
                                                    id="comment-66"
                                                    class="comment_container"
                                                  >
                                                    <img
                                                      alt=""
                                                      src={
                                                        item?.customerDetails
                                                          ?.profileImage !==
                                                        "No"
                                                          ? item
                                                              ?.customerDetails
                                                              ?.profileImage
                                                          : "https://secure.gravatar.com/avatar/fef324744214c984589ca38081a24b5e?s=60&#038;d=mm&#038;r=g"
                                                      }
                                                      class="avatar avatar-60 photo"
                                                      height="60"
                                                      width="60"
                                                    />
                                                    <div class="comment-text">
                                                      <div
                                                        class="star-rating"
                                                        role="img"
                                                        aria-label="Rated 4 out of 5"
                                                      >
                                                        <span
                                                          style={{
                                                            width: `${
                                                              (product
                                                                ?.averageRatingsDetails?.[0]
                                                                ?.averageRating /
                                                                5) *
                                                              100
                                                            }%`,
                                                          }}
                                                        >
                                                          Rated
                                                          <strong class="rating">
                                                            {item?.starRating}{" "}
                                                          </strong>
                                                          out of 5
                                                        </span>
                                                      </div>
                                                      <p class="meta">
                                                        <strong class="woocommerce-review__author">
                                                          {
                                                            item
                                                              ?.customerDetails
                                                              ?.customerName
                                                          }
                                                        </strong>
                                                        <span class="woocommerce-review__dash">
                                                          &ndash;
                                                        </span>
                                                        <time
                                                          class="woocommerce-review__published-date"
                                                          datetime="2024-12-06T06:39:33+00:00"
                                                        >
                                                          {moment(
                                                            item?.ratingDate
                                                          ).format(
                                                            "DD-MM-YYYY"
                                                          )}
                                                        </time>
                                                      </p>

                                                      <div class="description">
                                                        <p>
                                                          {item?.reviewComment}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </li>
                                              )
                                            )}
                                          </ol>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {tab === "shippingReviews" && (
                                    <div
                                      class="woocommerce-Tabs-panel woocommerce-Tabs-panel--furniforma_materialcare panel entry-content wc-tab"
                                      id="tab-furniforma_materialcare"
                                      role="tabpanel"
                                      aria-labelledby="tab-title-furniforma_materialcare"
                                    >
                                      <h2>Delivery & returns</h2>

                                      <div
                                        data-elementor-type="page"
                                        data-elementor-id="706"
                                        class="elementor elementor-706"
                                      >
                                        <section
                                          class="elementor-section elementor-top-section elementor-element elementor-element-9aee882 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                                          data-id="9aee882"
                                          data-element_type="section"
                                          data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
                                        >
                                          <div class="elementor-container elementor-column-gap-no">
                                            <div
                                              class="elementor-column elementor-col-99 elementor-top-column elementor-element elementor-element-c5f2e79"
                                              data-id="c5f2e79"
                                              data-element_type="column"
                                            >
                                              <div class="elementor-widget-wrap elementor-element-populated">
                                                <div
                                                  class="elementor-element elementor-element-f720599 start  elementor-widget elementor-widget-wdt-heading"
                                                  data-id="f720599"
                                                  data-element_type="widget"
                                                  data-settings='{"item_align":"start","_animation":"fadeInUp","_animation_delay":300,"split_heading":"false","title_vertical_align":"center","subtitle_vertical_align":"center","wdt_animation_effect":"none"}'
                                                  data-widget_type="wdt-heading.default"
                                                >
                                                  <div class="elementor-widget-container">
                                                    <div
                                                      class="wdt-heading-holder wdt-heading-wrapper-start"
                                                      id="wdt-heading-f720599"
                                                    >
                                                      <div class="wdt-heading-content-wrapper">
                                                        We deliver to over 100
                                                        countries around the
                                                        world. For full details
                                                        of the delivery options
                                                        we offer, please view
                                                        our{" "}
                                                        <Link>
                                                          Delivery information
                                                        </Link>
                                                        <br />
                                                        <br />
                                                        We hope you’ll love
                                                        every purchase, but if
                                                        you ever need to return
                                                        an item you can do so
                                                        within a month of
                                                        receipt. For full
                                                        details of how to make a
                                                        return, please view our{" "}
                                                        <Link>
                                                          Returns information
                                                        </Link>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </section>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {product?.relatedProducts?.length > 0 && (
                  <section
                    class="custom-slider-home-2  elementor-section elementor-top-section elementor-element elementor-element-2353da2 elementor-section-boxed elementor-section-height-default elementor-section-height-default "
                    data-id="2353da2"
                    data-element_type="section"
                    data-settings='{"animation":"fadeInUp","animation_delay":200,"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
                  >
                    <div class="elementor-container elementor-column-gap-no">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e7a5402"
                        data-id="e7a5402"
                        data-element_type="column"
                      >
                        <div class="elementor-widget-wrap elementor-element-populated">
                          <div
                            class="elementor-element elementor-element-5459ec2 wdt-cus-product-single-related-products elementor-widget elementor-widget-wdt-shop-related-products"
                            data-id="5459ec2"
                            data-element_type="widget"
                            data-settings='{"carousel_slidesperview_tablet_extra":"3","carousel_slidesperview":4,"carousel_slidesperview_laptop":4,"carousel_slidesperview_tablet":2,"carousel_slidesperview_mobile_extra":1,"carousel_slidesperview_mobile":1,"wdt_animation_effect":"none"}'
                            data-widget_type="wdt-shop-related-products.default"
                          >
                            <div class="elementor-widget-container">
                              <div
                                class="wdt-product-related-products wdt-woo-carousel"
                                data-carousel_mousewheelcontrol=""
                                data-carousel_bulletpagination=""
                                data-carousel_arrowpagination="true"
                                data-carousel_spacebetween="30"
                                data-carouselslidesperview="4"
                                data-carouselresponsive='{"carousel_slidesperview":4,"responsive":[{"breakpoint":319,"toshow":1,"toscroll":1,"space_between":20},{"breakpoint":480,"toshow":1,"toscroll":1,"space_between":30},{"breakpoint":768,"toshow":2,"toscroll":1,"space_between":30},{"breakpoint":1025,"toshow":3,"toscroll":1,"space_between":20},{"breakpoint":1281,"toshow":4,"toscroll":1,"space_between":20},{"breakpoint":1541,"toshow":4,"toscroll":1,"space_between":30}]}'
                                data-layout="carousel"
                              >
                                <section class="related products">
                                  <h2>Related Products</h2>
                                  <div>
                                    <ul class="products columns-4 product-style-default product-hover-secimage-fade product-content-hover-slidebottom product-without-space product-padding-content wdt-cus-product-style-01 true product-label-boxed false product-thumb-alignment-bottom product-thumb-iconsgroup-position-horizontal horizontal-position-top-right product-thumb-iconsgroup-style-skinbrdrfill-rounded product-thumb-buttonelement-style-bgfill-square product-thumb-buttonelement-stretch product-content-alignment-center product-content-iconsgroup-style-simple product-content-buttonelement-style-simple furniforma-related-product-carousel">
                                      <li class="product isotope-grid-sizer">
                                        <div class="wdt-col wdt-col-xs-12 wdt-col-sm-6 wdt-col-md-6 wdt-col-qxlg-4 wdt-col-hxlg-3 wdt-col-lg-3"></div>
                                      </li>
                                      {product?.relatedProducts?.map(
                                        (item, i) => (
                                          <li
                                            onClick={() => {
                                              navigate(
                                                `/product-details/${item?.id}`
                                              );
                                            }}
                                            class="product-grid-view product type-product post-1064 status-publish first instock product_cat-furniture product_cat-wooden-chair product_tag-chair has-post-thumbnail sale shipping-taxable purchasable product-type-simple"
                                          >
                                            <div class="wdt-col wdt-col-xs-12 wdt-col-sm-6 wdt-col-md-6 wdt-col-qxlg-4 wdt-col-hxlg-3 wdt-col-lg-3">
                                              <div class="product-wrapper">
                                                <div class="product-thumb">
                                                  <Link
                                                    class="image"
                                                    to={`/product-details/${item?.id}`}
                                                    title="Solid Wood Chair"
                                                  >
                                                    <div class="product-thumb-overlay"></div>
                                                    {item?.label && (
                                                      <div class="product-labels">
                                                        <span class="new">
                                                          <span>
                                                            {item?.label}
                                                          </span>
                                                        </span>
                                                      </div>
                                                    )}
                                                    <div class="primary-image">
                                                      <img
                                                        decoding="async"
                                                        src={
                                                          JSON.parse(
                                                            item?.productGallery ||
                                                              "[]"
                                                          )?.[0]
                                                        }
                                                        alt="Shop Primary Image"
                                                        title="Shop Primary Image"
                                                      />
                                                    </div>
                                                  </Link>
                                                  <div class="product-thumb-content">
                                                    <div class="product-buttons-wrapper product-button">
                                                      <div class="wc_inline_buttons">
                                                        <div
                                                          class="wcct_btn_wrapper wc_btn_inline"
                                                          data-tooltip="Add To Cart"
                                                        >
                                                          <Link
                                                            onClick={() => {
                                                              handleCartBtn(
                                                                item
                                                              );
                                                            }}
                                                            class="wdt-button too-small button product_type_simple add_to_cart_button ajax_add_to_cart"
                                                          >
                                                            Add to cart
                                                          </Link>
                                                          <span
                                                            id="woocommerce_loop_add_to_cart_link_describedby_1631"
                                                            class="wdt-button too-small screen-reader-text"
                                                          ></span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="product-element-group-wrapper">
                                                      <div class="product-element-group-items">
                                                        <div class="product-buttons-wrapper product-icons">
                                                          <div class="wc_inline_buttons">
                                                            <div
                                                              class="wcct_btn_wrapper wc_btn_inline"
                                                              data-tooltip="Add To Cart"
                                                            >
                                                              <Link
                                                                onClick={() => {
                                                                  handleCartBtn(
                                                                    item
                                                                  );
                                                                }}
                                                                class="wdt-button too-small button product_type_simple add_to_cart_button ajax_add_to_cart"
                                                              >
                                                                Add to cart
                                                              </Link>
                                                              <span
                                                                id="woocommerce_loop_add_to_cart_link_describedby_1631"
                                                                class="wdt-button too-small screen-reader-text"
                                                              ></span>
                                                            </div>
                                                            <div
                                                              class="wcwl_btn_wrapper wc_btn_inline"
                                                              data-tooltip="Wishlist"
                                                            >
                                                              <div
                                                                class="tinv-wraper woocommerce tinv-wishlist tinvwl-shortcode-add-to-cart tinvwl-furniforma_woo_loop_product_button_elements_wishlist"
                                                                data-tinvwl_product_id="1631"
                                                              >
                                                                <div class="tinv-wishlist-clear"></div>
                                                                {wishList?.find(
                                                                  (er) =>
                                                                    er
                                                                      ?.productDetails
                                                                      ?.id ===
                                                                    item?.id
                                                                ) ? (
                                                                  <Link
                                                                    to="/wishlist"
                                                                    role="button"
                                                                    class="tinvwl_add_to_wishlist_button tinvwl-icon-heart tinvwl-product-already-on-wishlist tinvwl-position-after  inited-add-wishlist tinvwl-product-in-list"
                                                                    tabindex="0"
                                                                  >
                                                                    <span class="tinvwl_add_to_wishlist-text">
                                                                      Go to
                                                                      Wishlist
                                                                    </span>
                                                                  </Link>
                                                                ) : (
                                                                  <Link
                                                                    onClick={() => {
                                                                      handleWhishListBtn(
                                                                        item
                                                                      );
                                                                    }}
                                                                    role="button"
                                                                    class="tinvwl_add_to_wishlist_button tinvwl-icon-heart tinvwl-product-already-on-wishlist tinvwl-position-after"
                                                                    tabindex="0"
                                                                  >
                                                                    <span class="tinvwl_add_to_wishlist-text">
                                                                      Add to
                                                                      Wishlist
                                                                    </span>
                                                                  </Link>
                                                                )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="product-details">
                                                  <div class="product-title">
                                                    <h5>
                                                      <Link
                                                        to={`/product-details/${item?.id}`}
                                                      >
                                                        {item?.productName}
                                                      </Link>
                                                    </h5>
                                                  </div>
                                                  <div class="product-price">
                                                    <span class="price">
                                                      <span
                                                        class="woocs_price_code"
                                                        data-currency=""
                                                        data-redraw-id="67ad7161b1e8e"
                                                        data-product-id="1631"
                                                      >
                                                        <ins aria-hidden="true">
                                                          <span class="woocommerce-Price-amount amount">
                                                            <bdi>
                                                              <span class="woocommerce-Price-currencySymbol">
                                                                &#8377;
                                                              </span>
                                                              &nbsp;
                                                              {
                                                                item
                                                                  ?.variants?.[0]
                                                                  ?.price
                                                              }
                                                            </bdi>
                                                          </span>
                                                        </ins>
                                                        <span class="screen-reader-text">
                                                          Current price is:
                                                          &#036;&nbsp;
                                                          {
                                                            item?.variants?.[0]
                                                              ?.price
                                                          }
                                                          .
                                                        </span>
                                                      </span>
                                                    </span>
                                                  </div>
                                                  <div class="product-rating-wrapper">
                                                    <div
                                                      class="star-rating"
                                                      role="img"
                                                      aria-label="Rated 4.00 out of 5"
                                                    >
                                                      <span
                                                        style={{
                                                          width: `${
                                                            (+item
                                                              ?.averageRatingsDetails?.[0]
                                                              ?.averageRating /
                                                              5) *
                                                            100
                                                          }%`,
                                                        }}
                                                      >
                                                        Rated
                                                        <strong class="rating">
                                                          {
                                                            +item
                                                              ?.averageRatingsDetails?.[0]
                                                              ?.averageRating
                                                          }
                                                          .00
                                                        </strong>
                                                        out of 5
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  </div>
                                </section>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )}
              </div>
            </div>
          </section>
        </div>

        {addReviewModal && (
          <Modal
            open={addReviewModal}
            onClose={() => setAddReviewModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: isMobile ? 350 : isTablet ? 450 : 600,
                bgcolor: "background.paper",
                boxShadow: 24,
                borderRadius: 4,
                p: 2,
              }}
            >
              {addReviewStatus ? (
                <div className="modal-content">
                  <div className="modal-header bg-secondary p-2">
                    <h5 className="pt-1 mx-3 text-white">Rate This Product</h5>
                  </div>
                  <div className="modal-body">
                    <div style={{ padding: "" }}>
                      <form onSubmit={(e) => handleSubmitReview(e)}>
                        <div className="">
                          <div
                            className=""
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 10,
                            }}
                          >
                            <label htmlFor="rating" className="text-dark">
                              Your rating{" "}
                              <span className="span-required">*</span>{" "}
                            </label>

                            <div class="rating">
                              {[1, 2, 3, 4, 5].reverse().map((num, index) => (
                                <>
                                  <input
                                    type="radio"
                                    id={`star${num}`}
                                    name="rating"
                                    value={ratingInputData?.rating}
                                    onChange={(e) => {
                                      setRatingInputData({
                                        ...ratingInputData,
                                        rating: num,
                                      });
                                    }}
                                  />
                                  <label
                                    class="star"
                                    for={`star${num}`}
                                    title="Awesome"
                                    aria-hidden="true"
                                  ></label>
                                </>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="">
                          <label htmlFor="singin-email-2">
                            Description <span className="span-required">*</span>
                          </label>
                          <textarea
                            type="text"
                            className={`form-control ${
                              descriptionError && "border-danger"
                            }`}
                            id="singin-email-2"
                            name="singin-email"
                            required
                            placeholder="Enter a Description"
                            value={ratingInputData?.description}
                            onChange={(e) => {
                              setRatingInputData({
                                ...ratingInputData,
                                description: e.target.value,
                              });

                              if (e.target.value.length >= 3) {
                                setDescriptionError(false);
                              } else {
                                setDescriptionError(true);
                              }
                            }}
                          />
                        </div>

                        <div className="form-footer" style={{ marginTop: 10 }}>
                          <button
                            type="submit"
                            disabled={loading}
                            className="btn btn-outline-primary-2"
                          >
                            <span>SAVE </span>
                            <i className="icon-long-arrow-right"></i>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="modal-content">
                  {" "}
                  <div className="modal-content">
                    <div className="modal-body">
                      <div style={{ padding: "2rem" }}>
                        <div>
                          <div className="cus-icon cus-warning">
                            <span className="cus-body"></span>
                            <span className="cus-dot"></span>
                          </div>
                        </div>

                        <div className="d-flex justify-content-center align-items-center mt-3 flex-column">
                          <h3 className="" style={{ color: "#9bc575" }}>
                            {alreadyReviewStatus
                              ? "Already Reviewed this Product!"
                              : "Haven't purchased this product?"}
                          </h3>
                          <h6 className="" style={{}}>
                            {alreadyReviewStatus
                              ? "Sorry! You have already submitted a review for this product."
                              : " Sorry! You are not allowed to review this product since you haven't purchase it."}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Box>
          </Modal>
        )}

        {loginModal && <Login open={loginModal} setOpen={setLoginModal} />}
      </div>

      {/* Open in App Banner for Mobile */}
      {showOpenInAppBanner && product?.id && (
        <OpenInAppBanner productId={product.id} productName={product.name} />
      )}
    </>
  );
};

export default ProductDetails;
